export const purchaseOrderDetailsRoutes = [
  {
    path: ':reference_number',
    name: 'purchase-order-details',
    component: () =>
      import(/* webpackChunkName: "Purchase-order-details" */ './PurchaseOrderDetails.vue')
  }
];
